<template>
  <v-row align="center">
    <br />
    <div class="icon">
      <div class="siteLink">
        <a :href="url1" @click="clickData1" target="”_blank”">
          <p>公式サイト</p>
        </a>
      </div>

      <div>
        <a :href="url2" @click="clickData2" target="”_blank”">
          <img
            class="img"
            src="../assets/microsoftStore.png"
            v-bind:style="height"
          />
        </a>
      </div>
    </div>
  </v-row>
</template>

<script>
import firebase from "firebase";
export default {
  name: "icoon",
  props: ["name1", "name2", "imgSrc", "height", "url1", "url2"],
  methods: {
    clickData1: function() {
      firebase.analytics().logEvent(this.name1);
    },
    clickData2: function() {
      firebase.analytics().logEvent(this.name2);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon {
  margin-top: 5%;

  /* text-align: center; */
}
#title {
  font-size: 16px;
  text-align: center;
}
.img {
  height: 50px;
  margin-top: 20px;
}
.siteLink {
  text-align: center;
}

/*リンクの下線、色を消す*/
a {
  display: block;
  text-decoration: none;
  color: black;
}

/*リンクの下線、色を消す*/
a:active {
  text-decoration: none;
  color: black;
}
@media screen and (min-width: 700px) {
  /* 959px以下に適用されるCSS（タブレット用） */
  .siteLink p {
    font-size: 20px;
    height: 40px;
    /* width:60%; */
    color: white;
    background-color: rgb(2, 160, 254);
    font-weight: bold;
    border-radius: 10px;
    border-color: black;
    /* margin-left: 20%; */
    padding-top: 6px;
  }
}
@media screen and (max-width: 699px) {
  /* 480px以下に適用されるCSS（スマホ用） */
  .siteLink {
    display: inline-block;
    width: 150px;
  }
  .siteLink p {
    font-size: 20px;
    height: 40px;
    color: white;
    background-color: rgb(2, 160, 254);
    font-weight: bold;
    border-radius: 10px;
    padding-top: 6px;
  }
}
</style>
